import { questionTypes } from 'sharedParts';

export const addPageNumbersToSection = (sectionBlocks, startPageNumber = 0) => {
  if (sectionBlocks.length === 0) {
    return {
      sectionBlocks,
      pageCount: 0,
    };
  }
  let currentPageNumberIncrease = 0;
  const result = sectionBlocks.map((block, i) => {
    const currentPage = startPageNumber + currentPageNumberIncrease;
    const currentBlock = {
      ...block,
      page: currentPage,
    };
    const isLastElement = sectionBlocks.length - 1 === i;
    if (block.type === questionTypes.nextButton && !isLastElement) {
      currentPageNumberIncrease++;
    }
    return currentBlock;
  });

  return {
    sectionBlocks: result,
    pageCount: currentPageNumberIncrease + 1,
  };
};

export const addPageNumbersToSections = sectionsObject => {
  const result = {};
  let currentPage = 0;

  Object.keys(sectionsObject).forEach(sectionName => {
    const section = sectionsObject[sectionName];
    const { sectionBlocks, pageCount } = addPageNumbersToSection(
      section,
      currentPage,
    );
    currentPage += pageCount;
    result[sectionName] = sectionBlocks;
  });

  return result;
};
